import type { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import type { IUserMilestone } from "@faire/web-api--source/indigofair/data/IUserMilestone";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";

export function getMilestoneInteractionsByType(
  layoutElement: ILayoutElement,
  type: keyof typeof ILayoutElement.IMilestoneInteraction.InteractionType
): IUserMilestone.RetailerMilestone[] {
  return [
    layoutElement.milestone_interaction,
    ...(layoutElement.milestone_interactions || []),
  ]
    .map((i) =>
      i?.type === type ? i?.user_milestone?.retailer_milestone : undefined
    )
    .filter(isNotUndefined);
}
